import { useSelector } from 'react-redux';
import {
  getJobManagerTableData,
  getJobManagerTableFilter,
} from 'modules/jobManager/ducks/selectors';
import { DEFAULT_ROW_COUNT } from 'modules/jobManager/constants';
import { useJobManagerTranslations } from 'modules/jobManager/hooks';
import { TableRow as TableRowType } from 'modules/jobManager/types';
import { EmptyState as EmptyStateIllustration, NoResult } from 'ui/illustrations';
import { EmptyState } from 'ui/emptyState';
import { SkeletonRow } from './SkeletonRow';
import { NoDataContainer } from './Styled';
import { TableRow } from './TableRow';

export const TableBody = () => {
  const { t, ct } = useJobManagerTranslations();
  const { loading, items } = useSelector(getJobManagerTableData);
  const { jobStates, jobTypeNames } = useSelector(getJobManagerTableFilter);

  const tableContent = () => {
    switch (true) {
      case loading:
        return [...Array(DEFAULT_ROW_COUNT)].map((_, i) => <SkeletonRow key={i} />);

      case items.length > 0:
        return items.map((row: TableRowType) => (
          <TableRow key={`conversion-row-${row.id}`} row={row} />
        ));

      case [...jobStates, ...jobTypeNames].length > 0 && items.length === 0:
        return (
          <NoDataContainer>
            <EmptyState
              title={ct('emptyState.table.titleVariant1')}
              subtitle={ct('emptyState.table.subTitle')}
              Illustration={NoResult}
            />
          </NoDataContainer>
        );

      default:
        return (
          <NoDataContainer>
            <EmptyState
              title={t('noData.title')}
              subtitle=""
              Illustration={EmptyStateIllustration}
            />
          </NoDataContainer>
        );
    }
  };
  return <>{tableContent()}</>;
};
